import { FC, PropsWithChildren, ReactNode } from "react";
import { Loading } from "../Loading";

type GeneralTemplateProps = {
  header: ReactNode;
  loading?: boolean;
  dialog?: ReactNode;
  toast?: ReactNode;
};

export const GeneralTemplate: FC<PropsWithChildren<GeneralTemplateProps>> = (props) => {
  const { children, header, dialog, loading, toast } = props;
  return (
    <>
      <div className="flex h-full w-full flex-col items-center bg-gray-100">
        {header}
        {children}
      </div>
      {loading && <Loading />}
      {toast && toast}
      {dialog && dialog}
    </>
  );
};
